/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMobileDeviceOrdered,
    ReadOnlyMobileDeviceOrderedFromJSON,
    ReadOnlyMobileDeviceOrderedFromJSONTyped,
    ReadOnlyMobileDeviceOrderedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20018
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20018
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20018
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMobileDeviceOrdered>}
     * @memberof InlineResponse20018
     */
    results: Array<ReadOnlyMobileDeviceOrdered>;
}

export function InlineResponse20018FromJSON(json: any): InlineResponse20018 {
    return InlineResponse20018FromJSONTyped(json, false);
}

export function InlineResponse20018FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20018 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMobileDeviceOrderedFromJSON)),
    };
}

export function InlineResponse20018ToJSON(value?: InlineResponse20018 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMobileDeviceOrderedToJSON)),
    };
}


